import {
  withFmaSliceSettings, fmaFullFieldSettings, fmaCircularParameter,
  wavefrontPolynomialOptions, wavefrontPolynomialVariants, wavefrontPolynomialFieldParameters,
} from './shared.js';

export default {
  label: 'Wavefront polynomial field map', group: 'performance',
  description: 'A Zernike coefficient, or the magnitude of a pair of terms, over a two-dimensional grid of field points.',
  settingsSchema: withFmaSliceSettings({ ...wavefrontPolynomialOptions, ...fmaFullFieldSettings }, wavefrontPolynomialVariants),
  parameters: [fmaCircularParameter, ...wavefrontPolynomialFieldParameters],
  coverage: 'For focal (non-afocal) systems, on a circular or rectangular field grid. Color shows the coefficient or magnitude in waves at the wavelength CODE V reports; orientations are listed in a separate table. A single term can be negative. Coefficient 0 is not supported.',
} as const;
